// @flow
import React from 'react';
import {compose} from 'redux';
import {connect} from 'react-redux';
import {AppBanner} from '@homeaway/react-app-banner';
import {EdapProvider} from '@homeaway/react-event-tracking';
import type {State as ReduxState} from '../../reducers/index';
type StateProps = {
    fullLocale: string,
    isAndroid: boolean
};

type Props = StateProps;

const AppDownloadBanner = ({fullLocale, isAndroid}: Props) => {
    const mobileOS = isAndroid ? 'android' : 'ios';
    return (
        <EdapProvider>
            <AppBanner locale={fullLocale} mobileOS={mobileOS} page="serp" />
        </EdapProvider>
    );
};

const mapStateToProps = ({
    system: {fullLocale, isAndroid}
}: ReduxState): StateProps => ({
    fullLocale,
    isAndroid
});
export default compose(connect(mapStateToProps))(AppDownloadBanner);
